<template>
    <div class="page-wrapper">
        <!-- <div class="titleLine">
            <div class="left">商城</div>
            <div class="right"><button class="cg-btn mgl-16" @click="exportMallList">下载表格</button></div>
        </div>
        <div class="header-handle">
            <div class="search-box">
                <el-input
                    size="mini"
                    placeholder="ID/商品名称/款号/品牌"
                    prefix-icon="el-icon-search"
                    v-model.trim="searchWords"
                    clearable
                    >
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
        </div> -->
        <div class="mall-main">
            <div class="mall-crumb">
                <span class="item">全部结果</span>
                <em class="gap">&gt;</em>
                <span class="item cur">"{{searchWords}}"</span>
            </div>
            <div class="no-data" v-if="tableData.length == 0">
                <div class="img-none"></div>
                <div class="no-data-tip">抱歉，暂无符合搜索条件的商品</div>
            </div>
            <div class="table-wrap">
                <div class="goods-item" v-for="list in tableData" :key="list.item_id"  @click="toGoodsDetail(list)">
                    <div class="inner">
                        <div class="imgBox">
                            <el-image class="img" :src="list.mallItemFileUrl" fit="cover"></el-image>
                        </div>
                        <div class="nameLine">
                            <div class="goodTitle intwoline">{{list.itemName}}</div>
                            <div class="brand">{{list.brandName}} </div>
                        </div>
                        <div class="price">￥{{list.price | price}}</div>
                        <div class="bottomLine">
                            <div class="left">款号：{{list.styleNumber}}</div>
                            <div class="left">库存：{{list.stock}}件</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[8, 20, 40, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mallItemList, exportMallList } from '../../../api/dealer'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import moment from 'moment'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            fit:'cover',
            tableData: [],
            // 分页
            pageSize: 60,
            total: 0,
            currentPage: 1,
            mid: '',
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
        this.searchHandle()
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 60
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.mid = this.$route.query.mid || ''
                this.mallItemList();
            },
            immediate: true
        }
    },
    methods: {
        exportMallList() {
            exportMallList({
                user_id: '',
                user_token: '',
                image_type: 12104,  // 12104 - 缩略图   12101 - 原图
                item_state: 1,
            }).then(res => {
                console.log(res)
                if (res.error_code == 0) {
                    this.$message.success('成功获取下载链接！')
                    saveAs(res.data.file, `zciiss数字云仓_商城商品_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                    // window.location.href=res.data.file;
                } else {
                    this.$message.error(res.error_msg || '下载失败！')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        mallItemList() {
            this.loading = true
            mallItemList({
                fuzzyQuery: this.searchWords,
                page: this.currentPage,
                num: this.pageSize,
                defaultValue: '1',  // defaultValue 这个字段是为了与 衣加加APP中的云仓商品列表作区分
                userId: this.mid || ''
            }).then(res => {
                this.loading = false
                console.log('mallItemList-res', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.mallItemList.map(item => {
                        return {
                            ...item,
                            mallItemFileUrl: process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl
                        }
                    })
                    this.total = parseInt(res.data.totalCount)
                } else if (res.errorCode == -10111) {
                    // 暂无商品列表
                    this.tableData = []
                    this.total = 0
                    this.$message.error(res.errorMsg || '暂无商品列表')
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log('mallItemList-err', err)
            })
        },
        searchHandle() {
            this.$bus.$on('dw-search-word', data => {
                this.searchWords = data
                this.currentPage = 1
                this.curRoutePush()
            })
        },
        toGoodsDetail(row) {
            console.log(row);
            this.$router.push('/dealer/goods/detail?id=' + row.item_id)
        },
        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            console.log(val)
            console.log(`每页 ${val} 条`);
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/dealer/goods/list?mid='+ this.mid + '&search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            console.log(val)
            console.log(`当前页: ${val}`);
            this.currentPage = val
            this.curRoutePush()
        },
    },
}
</script>

<style lang="scss" scoped>
.mall-crumb {
    padding: 40px 0 20px;
    line-height: 22px;
    .item {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        &.cur {
            color: rgba(0, 0, 0, 0.65);
        }
    }
    .gap {
        font-weight: normal;
        font-size: 14px;
        margin:0 8px;
        color: rgba(0, 0, 0, 0.45);
        transform: scale(1, 1.4);
        display: inline-block;
    }
}
.mall-main {
    margin: 0 auto;
    width: 1132px;
    padding-bottom: 20px;
}
.table-wrap {
    margin: 0 -10px;
    background: #fff;
}

.goods-item{
    width: 25%; display: inline-block; box-sizing: border-box; padding: 20px 10px;
    .inner {
        border:1px solid #efefef; 
        &:hover {
            box-shadow: 0 0px 20px #ddd;
        }
    }
    .imgBox{
        height:280px; cursor: pointer;
        .img{width:100%; height: 280px;}
    }
    .nameLine{
        height: 60px;
       .goodTitle{color:#2A2E3F;font-size: 16px;margin:16px;line-height: 20px; width: 210px;margin-bottom:0px;
           max-height: 40px; cursor: pointer;
       } 
       .brand{color:#666666;font-size: 12px;padding-left:16px;}
    }
    .price{color:#E11010;font-size: 24px;padding-left:16px;}
    .bottomLine{
        padding:0 16px 10px;color:#666666;font-size: 12px;
    }
}
.titleLine{display: flex;
    .left{flex:1;color:#333;font-size: 30px;font-weight: bold;}
    .right{flex:1;text-align: right;}
}
.no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 120px 0;
    .img-none {
        width: 240px;
        height: 126px;
        background: url(../../../assets/img_no_login.png) no-repeat;
        background-size: cover;
    }
    .no-data-tip {
        margin-top: 20px;
        font-size: 16px;
        color: #333;
        line-height: 32px;
    }
}

</style>